module.exports = __webpack_public_path__ + "img/ring_r_e_null_null.e763e7c4.png";